import { createContext } from 'react';

export type TenantContext = {
  tenant: string;
  contextPath: string;
  spaMode: boolean;
  configuration?: {
    currency: string;
    showDispatchTransition: boolean;
    // @hipaa-exclude
    qboEnabled: boolean;
  };
};

export const TenantContext = createContext<TenantContext>({ tenant: '', contextPath: '', spaMode: false });
